<template>
  <div class="hero-gallery" :style="scrollStyle" aria-hidden="true">
    <div
      v-for="(item, index) in photos"
      :key="item.imagen + index"
      class="hero-slide"
      :class="{ 'is-active': index === current }"
    >
      <img
        :src="`${base}/img/gallery/${item.imagen}`"
        alt=""
        :loading="index === 0 ? 'eager' : 'lazy'"
        decoding="async"
      />
    </div>
  </div>
</template>

<script>
import axios from "@/directives/axios.js";

const SLIDE_MS = 8000;

export default {
  name: "galeryPhoto",
  data() {
    return {
      current: 0,
      photos: [],
      timer: null,
      scrollY: 0,
      ticking: false,
      base: this.$media,
    };
  },
  computed: {
    // Al hacer scroll la imagen se difumina y oscurece poco a poco
    scrollStyle() {
      const p = Math.min(this.scrollY / 800, 1);
      return {
        filter: p > 0 ? `blur(${(p * 8).toFixed(1)}px)` : "none",
        opacity: (1 - p * 0.6).toFixed(2),
      };
    },
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll, { passive: true });
    document.addEventListener("visibilitychange", this.onVisibility);
    this.cargarFotos();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
    document.removeEventListener("visibilitychange", this.onVisibility);
    this.stop();
  },
  methods: {
    async cargarFotos() {
      try {
        const { data } = await axios.get("/imagenes/galeriaImagenes?id=1");
        this.photos = (data.galerias && data.galerias.imagenes) || [];
        this.start();
      } catch (e) {
        this.photos = [];
      }
    },
    start() {
      this.stop();
      const reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (this.photos.length > 1 && !reduced) {
        this.timer = setInterval(this.next, SLIDE_MS);
      }
    },
    stop() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    },
    next() {
      this.current = (this.current + 1) % this.photos.length;
    },
    onVisibility() {
      document.hidden ? this.stop() : this.start();
    },
    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.scrollY = window.scrollY;
        this.ticking = false;
      });
    },
  },
};
</script>

<style scoped>
.hero-gallery {
  position: fixed;
  inset: 0;
  z-index: -1;
  background: #0b1221;
  will-change: filter, opacity;
}

.hero-slide {
  position: absolute;
  inset: 0;
  overflow: hidden;
  opacity: 0;
  transition: opacity 1.6s ease;
}

.hero-slide.is-active {
  opacity: 1;
}

.hero-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero-slide.is-active img {
  animation: hero-zoom 16s ease-out both;
}

@keyframes hero-zoom {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.12);
  }
}

@media (prefers-reduced-motion: reduce) {
  .hero-slide {
    transition: none;
  }
  .hero-slide.is-active img {
    animation: none;
  }
}
</style>
